import { useMutation } from 'react-query';
import { authFetch } from '../../../../CommonUtils/authFetch';

const disconnectRequest = async name => {
  const body = new FormData();
  body.append('Name', name);

  return authFetch('/Adviser/Settings/DeleteIntegration', {
    method: 'POST',
    body,
  });
};

export const useDisconnectIntegration = () => {
  return useMutation(disconnectRequest);
};
